export function validateHubSelection(selectedHubs: any[]): {
    isValid: boolean;
    reason?: string;
    hasDedicated?: boolean;
} {
    if (!selectedHubs || selectedHubs?.length === 0) {
        return { isValid: true };
    }

    const hasDedicated = selectedHubs.some(
        (hub) => !!hub?.hubId && !!hub?.hubInfo?.dedicatedSlotBookingEnabled,
    );
    const normalHubs = selectedHubs.filter(
        (hub) => !!hub?.hubId && !hub?.hubInfo?.dedicatedSlotBookingEnabled,
    );
    console.log(
        'validateHubSelection',
        'hasDedicated',
        hasDedicated,
        'normalHubs',
        normalHubs,
        'selectedHubs',
        selectedHubs,
    );
    if (hasDedicated && normalHubs?.length > 0) {
        return {
            isValid: false,
            reason: 'Cannot select other hubs along with a dedicated hub.',
            hasDedicated,
        };
    }

    if (
        hasDedicated &&
        selectedHubs?.filter((hub) => !!hub?.hubId)?.length > 1
    ) {
        return {
            isValid: false,
            reason: 'Only one dedicated hub can be selected.',
            hasDedicated,
        };
    }

    return { isValid: true, hasDedicated: hasDedicated };
}
